import React, { useState} from 'react';
import { Link, useNavigate } from "react-router-dom";
import { doForgotPasswordActivation } from '../../Service';
import Swal from "sweetalert2";
import { useParams } from "react-router";


export default function LoginHome(){ 
    const { id } = useParams();
    const navigation = useNavigate();
    const initialValues = { password: "", confrim_password: ""};
    const [formValues, setFormValues] = useState(initialValues);
    const [formErrors, setFormErrors] = useState({});

    const hanldeChange = (e) => {
		formValues[e.target.name]=  e.target.value;
		setFormValues(formValues);
	}

	const handleSubmit = (e) => {
        e.preventDefault();
        const errorCount = validate(formValues);
        setFormErrors(errorCount);
        if(errorCount.status){
          var bodyFormData = new FormData();
          bodyFormData.append('id', id);
          bodyFormData.append('password', formValues.password);
          bodyFormData.append('password_confirmation', formValues.confrim_password);
          doForgotPasswordActivation(bodyFormData).then(res => handleResponse(res, e));
        }
	}

    const handleResponse = (response, e) => {
      if(response.data.code==200){
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'New Password Updated Successfully!',
            showConfirmButton: false,
            timer: 2500
          })
          e.target.reset();
          setTimeout(() => navigation('/login'), 3000);
          
      } else {
        const errors = {};
        errors.invalid = response.data.message;
        errors.status = false;
        setFormErrors(errors);
      }  
    }


		const validate = (values) => {
			const errors = {};
			errors.status = true;

			if(!values.password){
				errors.email = 'New password is required';
				errors.status = false;
			} 

            if(!values.confrim_password){
				errors.email = 'Confrim new password is required';
				errors.status = false;
			} 
			return errors;
		}


    

  // JSX code for login form
    const renderForm = (

    <div className="form">
      <form onSubmit={handleSubmit}>
        <div className="input-container">
            <label>New Password</label>
            <input type="password" name="password" onChange={hanldeChange} />
            <p className="error">{formErrors.password}</p>
        </div>
        <div className="input-container">
            <label>Confrim new Password</label>
            <input type="password" name="confrim_password" onChange={hanldeChange} />
            <p className="error">{formErrors.invalid}{formErrors.confrim_password}</p>
        </div>
        <div className="button-container">
          <input type="submit" />
        </div>
      </form>
    </div>
   
   );

   return (
  
  <section className="Login-container" >
    <div className='container'>   
        <div className='row'>
          <div className='co1-md-12'>
            <img className='img-responsive' src={process.env.PUBLIC_URL+'/assets/logo.png'}/>
            <h1>Set New Password</h1>
            {renderForm}
          </div>
        </div>
     </div>
  </section>  
 
 
 
 
   );
 }